import React from 'react'
import { useActions, useValues } from 'kea'
import { LazyLoadComponent } from 'react-lazy-load-image-component'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTasks, faHeadset, faBullhorn } from '@fortawesome/free-solid-svg-icons'
import ReactHtmlParser from 'react-html-parser'

import I18n from 'lib/i18n'
import BreakOnBr from 'lib/tags/break-on-br'

import sceneLogic from '~/scenes/pages/request/logic'

const iconsObj = {
  bullhornIcon: faBullhorn,
  tasksIcon: faTasks,
  headsetIcon: faHeadset
}

const FirstPage = () => {
  const { nextPage } = useActions(sceneLogic)
  const { howItWorksTitles } = useValues(sceneLogic)

  const handleNextPage = event => {
    event.preventDefault()
    nextPage()
  }

  return (
    <div className='first-page'>
      <h1 className='landing-title'>
        <BreakOnBr text={I18n.t('react.request.front_page.landing_title')} />
      </h1>
      <p className='landing-subtitle'>{ReactHtmlParser(I18n.t('react.request.front_page.landing_subtitle'))}</p>
      <br />
      <div className='how-it-works-section-container'>
        {howItWorksTitles.map(({ text, icon }, index) => (
          <div key={`section#${index}`} className='how-it-works-section-container-scene'>
            <div className='scene-icon'>
              <LazyLoadComponent>
                <FontAwesomeIcon icon={iconsObj[icon]} size='5x' />
              </LazyLoadComponent>
            </div>
            <p className='how-it-works-section-container-scene-text'>{ReactHtmlParser(text)}</p>
          </div>
        ))}
      </div>
      <br />

      <div className='under-sections'>
        <button className='call-to-action' onClick={handleNextPage}>
          {I18n.t('react.request.front_page.call_to_action_button')}
        </button>
        <p className='text-under'>
          <BreakOnBr text={I18n.t('react.request.front_page.under_button_description')} />
        </p>
      </div>
    </div>
  )
}

export default FirstPage
